module.exports = angular;